module.exports = __webpack_public_path__ + "static/scaigatelogo-8275b141080a36756e9e29a337b95efc.png";